import { useQuery } from '@tanstack/react-query';

import { callGetNFTCollectionAssets } from '@app/client/resources/yat-pages/page-items';

import { type CommonNftQueryOptions } from './types';

export function useCollectionAssetsQuery({
    contractAddress = '',
    tokenId = '',
    keepPreviousData = false,
    refetchInterval = false,
}: CommonNftQueryOptions) {
    return useQuery(
        ['collection-assets', contractAddress, tokenId],
        ({ signal }) =>
            callGetNFTCollectionAssets({
                contract: contractAddress,
                itemId: tokenId,
                settings: {
                    signal,
                },
            }),
        {
            retry: false,
            enabled: Boolean(contractAddress && tokenId),
            keepPreviousData,
            refetchInterval,
        },
    );
}
